import React, {useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import * as auth from "../modules/Auth";
import {connect, shallowEqual, useSelector} from "react-redux";
import makeRequest from "../api/makeRequest";
const digits = (Number)=>{
	Number+= '';
	Number= Number.replace(',', ''); Number= Number.replace(',', ''); Number= Number.replace(',', '');
	Number= Number.replace(',', ''); Number= Number.replace(',', ''); Number= Number.replace(',', '');
	const x = Number.split('.');
	let y = x[0];
	const z= x.length > 1 ? '.' + x[1] : '';
	const rgx = /(\d+)(\d{3})/;
	while (rgx.test(y))
		y= y.replace(rgx, '$1' + ',' + '$2');
	return y+ z;
}
const Invoice = ({id = '', date = '', transaction = '', amount = 0, name = 'تست',onSetCoupon}) => {
	const {t} = useTranslation('common');

	const couponRef = useRef()
	const [error,setError] = useState('')
	const [successMsg,setSuccessMsg] = useState('')
	const [couponObj,setCouponObj] = useState({
		percent:0
	})
	const user = useSelector((state) => state.auth.user, shallowEqual);
	return (
		<>
			{/*begin::Wrapper*/}
			<div className="d-flex flex-column flex-row-fluid" id="kt_wrapper">
				{/*begin::Content*/}
				<div className="content  d-flex flex-column flex-column-fluid" id="kt_content">
					{/*begin::زیر هدر*/}
					<div className="subheader py-3 py-lg-8  subheader-transparent " id="kt_subheader">
						<div className=" container  d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
							{/*begin::اطلاعات*/}
							<div className="d-flex align-items-center flex-wrap mr-1">
								{/*begin::Page Heading*/}
								<div className="d-flex align-items-baseline flex-wrap mr-5">
									{/*begin::Page Title*/}
									{/*<h2 className="subheader-title text-dark font-weight-bold my-1 mr-3">
										{t('Invoice')}
									</h2>*/}
									{/*end::Page Title*/}
								</div>
								{/*end::Page Heading*/}
							</div>
							{/*end::اطلاعات*/}
						</div>
					</div>
					{/*end::زیر هدر*/}
					{/*begin::Entry*/}
					<div className="d-flex flex-column-fluid">
						{/*begin::Container*/}
						<div className=" container ">
							{/* begin::Card*/}
							<div className="card card-custom overflow-hidden">
								<div className="card-body p-0">
									{/* begin: فاکتور*/}
									{/* begin: فاکتور body*/}
									<div className="row justify-content-center py-8 px-8 py-md-10 px-md-0">
										<div className="col-md-9">
											<div className="table-responsive">
												<table className="table">
													<thead>
													<tr>
														<th className="pl-0 font-weight-bold text-muted  text-uppercase">{t('Details')}</th>
														<th className="text-right font-weight-bold text-muted text-uppercase">{t('Price')}</th>
													</tr>
													</thead>
													<tbody>
													<tr className="font-weight-boldest font-size-lg">
														<td className="pl-0 pt-7">{name}</td>
														<td className="text-danger pr-0 pt-7 text-right">{digits(Math.round(amount))}</td>
													</tr>
													{couponObj && couponObj.percent ? <tr className="font-weight-boldest font-size-lg">
														<td className="pl-0 pt-7">{t('Offer')}</td>
														<td className="text-success pr-0 pt-7 text-right">{digits(Math.round(amount * couponObj.percent / 100))} -</td>
													</tr> : null}
													<tr className="font-weight-boldest font-size-lg">
														<td className="pl-0 pt-7">{t('Tax')} (9%)</td>
														<td className="text-danger pr-0 pt-7 text-right">{digits(Math.round((amount - (amount * couponObj.percent / 100)) * 0.09))}</td>
													</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
									{/* end: فاکتور body*/}
									{/* begin: فاکتور footer*/}
									<div className="row justify-content-center bg-gray-100 py-8 px-8 py-md-10 px-md-0">
										<div className="col-md-9">
											<div className="d-flex justify-content-between flex-column flex-md-row font-size-lg">
												<div className="d-flex justify-content-between pt-6">
													{date && (
														<div className="d-flex flex-column flex-root">
															<span className="font-weight-bolde mb-2r">{t('Date')}</span>
															<span className="opacity-70">{date}</span>
														</div>
													)}
													{id && (
														<div className="d-flex flex-column flex-root">
															<span className="font-weight-bolder mb-2">{t('InvoiceNumber')}</span>
															<span className="opacity-70">BM {id}</span>
														</div>
													)}
													{/*<div className="d-flex flex-column flex-root">
													<span className="font-weight-bolder mb-2">آدرس خریدار</span>
													<span className="opacity-70">تهران - خیابان جمهوری <br />بازار موبایل ایران</span>
												</div>*/}
												</div>
												<div className="d-flex flex-column mb-10 mb-md-0">
													<div className="font-weight-bolder font-size-lg mb-3">{t('BuyerDetails')}</div>
													<div className="d-flex justify-content-between mb-3">
														<span className="mr-15 font-weight-bold">{t('CustomerName')}:</span>
														<span className="text-right">{user.name}</span>
													</div>
													<div className="d-flex justify-content-between mb-3">
														<span className="mr-15 font-weight-bold">{t('CustomerEmail')}:</span>
														<span className="text-right">{user.email}</span>
													</div>
													{transaction && (
														<div className="d-flex justify-content-between">
															<span className="mr-15 font-weight-bold">کد:</span>
															<span className="text-right">BARC0032UK</span>
														</div>
													)}
												</div>
												<div className="d-flex flex-column text-md-right">
													<span className="font-size-lg font-weight-bolder mb-1">{t('TheTmountPayable')}</span>
													<span
														className="font-size-h2 font-weight-boldest text-danger mb-1">{digits(Math.round(amount - (amount * couponObj.percent / 100) + ((amount - (amount * couponObj.percent / 100)) * 0.09)))} {t('Tooman')} </span>
												</div>
											</div>
										</div>
									</div>
									{/* end: فاکتور footer*/}
									{/* begin: فاکتور action*/}
									<div className="row justify-content-center py-8 px-8 py-md-10 px-md-0">
										<div className="col-md-9">
											<div className="d-flex justify-content-between">
												{/*<button type="button" className="btn btn-light-primary font-weight-bold"
																onClick={() => window.print()}>{t('DownloadTheInvoice')}</button>*/}
												<button type="button" className="btn btn-primary font-weight-bold"
																onClick={() => window.print()}>{t('PrintTheInvoice')}</button>
												<div>
													<label>{t('DiscountCode')}</label>
													<input disabled={successMsg} ref={couponRef} className='m-3 p-2' placeholder={t('EnterDiscountCode')}/>
													<button disabled={successMsg} type="button" className="btn btn-light-primary font-weight-bold"
																	onClick={async () => {
																		const {value} = couponRef.current
																		if(!value) return
																		setError('')
																		setSuccessMsg('')
																		try {
																			const {data} = await makeRequest('checkCoupon', {
																				coupon:value
																			})
																			const {success,error} = data
																			if(!success){
																				setError(error)
																				return
																			}
																			setSuccessMsg(t('Applycode'))
																			setCouponObj(data.coupon)
																			onSetCoupon(value)
																		} catch (e) {
																			console.log(e)
																		}
																	}}>{t('CheckCode')}
													</button>
													<div style={{color:"#3699ff"}}>{successMsg}</div>
													<div style={{color:"#F64E60"}}>{error}</div>
												</div>
											</div>
										</div>
									</div>
									{/* end: فاکتور action*/}
									{/* end: فاکتور*/}
								</div>
							</div>
							{/* end::Card*/}
						</div>
						{/*end::Container*/}
					</div>
					{/*end::Entry*/}
				</div>
				{/*end::Content*/}
			</div>
			{/*end::Wrapper*/}
		</>
	)
}
export default connect(null, auth.actions)(Invoice)